import React from "react";
import { Routes, Route } from "react-router-dom";
import { Shell } from "./components/Shell";
import { MfeLoader } from "./components/MfeLoader";
import { Home } from "./components/Home";
import { HowTo } from "./components/HowTo";
import { RemoteRegistryProvider } from "./registry/RemoteRegistryContext";
import { NotificationProvider } from "./context/NotificationContext";
import { useAuth } from "./auth/AuthContext";

function AppRoutes() {
  const { user } = useAuth();
  return (
    <NotificationProvider>
      <RemoteRegistryProvider userEmail={user.username} userName={user.name}>
        <Shell>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/how-to" element={<HowTo />} />
            <Route path="/:appName/*" element={<MfeLoader />} />
          </Routes>
        </Shell>
      </RemoteRegistryProvider>
    </NotificationProvider>
  );
}

export function App() {
  return <AppRoutes />;
}
